export const blogPosts = [
  {
    id: 1,
    image: "/BlogCardImage1.jpg",
    title: "Health claims, reimagined! Canvendor’s Agentic AI slashes delays",
    date: "Aug 14,2025",
  },
  {
    id: 2,
    image: "/BlogCardImage2.jpg",
    title: "Health claims, reimagined! Canvendor’s Agentic AI slashes delays",
    date: "Jun 10,2025",
  },
  {
    id: 3,
    image: "/BlogCardImage3.jpg",
    title: "Health claims, reimagined! Canvendor’s Agentic AI slashes delays",
    date: "May 20,2025",
  },
  {
    id: 4,
    image: "/BlogCardImage3.jpg",
    title:
      "How Agentic AI Will Transform Healthcare Claims Automation in 2026 and Beyond",
    date: "May 20,2025",
  },
  {
    id: 5,
    image: "/BlogsImages/blogBannerImage.png",
    title:
      "Cut QA Costs by 50%: How Agentic AI Automation Delivers Real ROI",
    date: "May 20,2025",
  },
];

export const blogContent = [
  {
    id: 1,
    title: "Health claims, reimagined! Canvendor’s Agentic AI slashes delays",
    image: "/BlogCardImage1.jpg",
    sections: [
      {
        heading: "TL; DR",
        content:
          "TL; DR Health claims, reimagined! Canvendor’s Agentic AI slashes delays, kills errors, and puts your claims on autopilot. Fast. Smart. Hassle-free. The future of healthcare claims is here! It’s easy to get frustrated, whether you’re at the hospital front desk, in the billing office, or on the insurance side of things. Delays, too much paperwork, and constant back-and-forths make the whole process feel stuck in the past. That’s exactly why Canvendor created Agentic AI — to make claims processing easier, more efficient, and faster. This smart solution is designed to eliminate regulatory roadblocks, reduce repetitive workload, and give your team the freedom to focus on what truly matters: patient care.",
        listHeading:
          "If you’re involved in hospital operations, insurance claims, or revenue cycle management, Agentic AI helps you:",
        list: [
          "Automate repetitive tasks",
          "Accelerate claim approvals",
          "Improve claim accuracy",
          "Monitor every step in real time",
        ],
        afterListContent:
          "No more digging through forms or chasing down paperwork. Just a clean, well-organized system that keeps everything flowing — minus the stress",
      },
      {
        heading: "What’s Holding Healthcare Claims Back?",
        content:
          "Many healthcare providers still rely on outdated, manual processes.",
        listHeading: "That leads to a range of familiar problems:",
        list: [
          "Payment delays",
          "Avoidable errors and data entry issues",
          "Claims getting rejected or lost",
          "Rising administrative costs",
          "Constant compliance worries",
        ],
        afterListContent: "",
      },
      {
        heading: "Here’s the Game-Changer: Cavendor’s AI Agent —",
        content:
          "Think of the AI Agent as a dependable partner — one that knows the ins and outs of healthcare claims and takes over the tedious parts, so your staff doesn’t have to.",
        listHeading: "Here’s how it works:",
        list: [
          "Understands Claims Intelligently: Automatically pulls important data from forms, bills, and supporting documents.",
          "Speeds Things Up: Detects and flags errors quickly so claims move through the system faster.",
          "Fits Into What You Already Use: Seamlessly integrates with your existing software and workflows.",
          "Always Audit-Ready: Tracks every step, making compliance reporting easy and stress-free.",
        ],
        afterListContent: "",
      },
      {
        heading: "Real Benefits You Can Measure",
        content:
          "Switching to Agentic AI isn’t just about convenience — it brings measurable improvements across your organization:",
        listHeading: "",
        list: [
          "Quicker Payments: Claims that used to take days can now be processed in hours.",
          "Improved Accuracy: Automated error checks reduce rework and rejected submissions.",
          "Reduced Costs: Less manual handling means more efficient operations.",
          "Happier Stakeholders: Patients and partners enjoy faster service and better communication.",
          "Live Visibility: Dashboards show what’s working, what’s lagging, and where to focus next.",
        ],
        afterListContent: "",
      },
      {
        heading: "Why Canvendor?",
        content:
          "At Canvendor, we don’t just make tools — we understand the real-world challenges that healthcare teams face.",
        listHeading:
          "That’s why we designed Agentic AI with features that matter:",
        list: [
          "Easy to implement and use",
          "Highly secure and scalable",
          "Compatible with your current workflows — no major overhauls required",
        ],
        afterListContent:
          "It’s smart automation that delivers — plain and simple.",
      },
      {
        heading: "Ready to Upgrade Your Claims Process?",
        content:
          "Let Agentic AI show you what’s possible when claims are done the smart way.",
        listHeading: "",
        list: [],
        afterListContent: "",
      },
    ],
    author: {
      name: "Pon Vijaya Prabu",
      role: "UI/UX Designer - Cavendor",
      image: "https://c.animaapp.com/memovagbcMSRxN/img/ellipse-11.svg",
      bio: "TL; DR Health claims, reimagined! Canvendor's Agentic AI slashes delays, kills errors, and puts your claims on autopilot. Fast. Smart. Hassle-free.",
    },
  },

  {
    id: 2,
    title: "Health claims, reimagined! Canvendor’s Agentic AI slashes delays",
    image: "/BlogCardImage2.jpg",
    sections: [
      {
        heading: "TL; DR",
        content:
          "TL; DR Health claims, reimagined! Canvendor’s Agentic AI slashes delays, kills errors, and puts your claims on autopilot. Fast. Smart. Hassle-free. The future of healthcare claims is here! It’s easy to get frustrated, whether you’re at the hospital front desk, in the billing office, or on the insurance side of things. Delays, too much paperwork, and constant back-and-forths make the whole process feel stuck in the past. That’s exactly why Canvendor created Agentic AI — to make claims processing easier, more efficient, and faster. This smart solution is designed to eliminate regulatory roadblocks, reduce repetitive workload, and give your team the freedom to focus on what truly matters: patient care.",
        listHeading:
          "If you’re involved in hospital operations, insurance claims, or revenue cycle management, Agentic AI helps you:",
        list: [
          "Automate repetitive tasks",
          "Accelerate claim approvals",
          "Improve claim accuracy",
          "Monitor every step in real time",
        ],
        afterListContent:
          "No more digging through forms or chasing down paperwork. Just a clean, well-organized system that keeps everything flowing — minus the stress",
      },
      {
        heading: "What’s Holding Healthcare Claims Back?",
        content:
          "Many healthcare providers still rely on outdated, manual processes.",
        listHeading: "That leads to a range of familiar problems:",
        list: [
          "Payment delays",
          "Avoidable errors and data entry issues",
          "Claims getting rejected or lost",
          "Rising administrative costs",
          "Constant compliance worries",
        ],
        afterListContent: "",
      },
      {
        heading: "Here’s the Game-Changer: Cavendor’s AI Agent —",
        content:
          "Think of the AI Agent as a dependable partner — one that knows the ins and outs of healthcare claims and takes over the tedious parts, so your staff doesn’t have to.",
        listHeading: "Here’s how it works:",
        list: [
          "Understands Claims Intelligently: Automatically pulls important data from forms, bills, and supporting documents.",
          "Speeds Things Up: Detects and flags errors quickly so claims move through the system faster.",
          "Fits Into What You Already Use: Seamlessly integrates with your existing software and workflows.",
          "Always Audit-Ready: Tracks every step, making compliance reporting easy and stress-free.",
        ],
        afterListContent: "",
      },
      {
        heading: "Real Benefits You Can Measure",
        content:
          "Switching to Agentic AI isn’t just about convenience — it brings measurable improvements across your organization:",
        listHeading: "",
        list: [
          "Quicker Payments: Claims that used to take days can now be processed in hours.",
          "Improved Accuracy: Automated error checks reduce rework and rejected submissions.",
          "Reduced Costs: Less manual handling means more efficient operations.",
          "Happier Stakeholders: Patients and partners enjoy faster service and better communication.",
          "Live Visibility: Dashboards show what’s working, what’s lagging, and where to focus next.",
        ],
        afterListContent: "",
      },
      {
        heading: "Why Canvendor?",
        content:
          "At Canvendor, we don’t just make tools — we understand the real-world challenges that healthcare teams face.",
        listHeading:
          "That’s why we designed Agentic AI with features that matter:",
        list: [
          "Easy to implement and use",
          "Highly secure and scalable",
          "Compatible with your current workflows — no major overhauls required",
        ],
        afterListContent:
          "It’s smart automation that delivers — plain and simple.",
      },
      {
        heading: "Ready to Upgrade Your Claims Process?",
        content:
          "Let Agentic AI show you what’s possible when claims are done the smart way.",
        listHeading: "",
        list: [],
        afterListContent: "",
      },
    ],
    author: {
      name: "Sivanesh",
      role: "React Developer - Cavendor",
      image: "https://c.animaapp.com/memovagbcMSRxN/img/ellipse-11.svg",
      bio: "TL; DR Health claims, reimagined! Canvendor's Agentic AI slashes delays, kills errors, and puts your claims on autopilot. Fast. Smart. Hassle-free.",
    },
  },

  {
    id: 3,
    title: "Health claims, reimagined! Canvendor’s Agentic AI slashes delays",
    image: "/BlogCardImage3.jpg",
    sections: [
      {
        heading: "TL; DR",
        content:
          "TL; DR Health claims, reimagined! Canvendor’s Agentic AI slashes delays, kills errors, and puts your claims on autopilot. Fast. Smart. Hassle-free. The future of healthcare claims is here! It’s easy to get frustrated, whether you’re at the hospital front desk, in the billing office, or on the insurance side of things. Delays, too much paperwork, and constant back-and-forths make the whole process feel stuck in the past. That’s exactly why Canvendor created Agentic AI — to make claims processing easier, more efficient, and faster. This smart solution is designed to eliminate regulatory roadblocks, reduce repetitive workload, and give your team the freedom to focus on what truly matters: patient care.",
        listHeading:
          "If you’re involved in hospital operations, insurance claims, or revenue cycle management, Agentic AI helps you:",
        list: [
          "Automate repetitive tasks",
          "Accelerate claim approvals",
          "Improve claim accuracy",
          "Monitor every step in real time",
        ],
        afterListContent:
          "No more digging through forms or chasing down paperwork. Just a clean, well-organized system that keeps everything flowing — minus the stress",
      },
      {
        heading: "What’s Holding Healthcare Claims Back?",
        content:
          "Many healthcare providers still rely on outdated, manual processes.",
        listHeading: "That leads to a range of familiar problems:",
        list: [
          "Payment delays",
          "Avoidable errors and data entry issues",
          "Claims getting rejected or lost",
          "Rising administrative costs",
          "Constant compliance worries",
        ],
        afterListContent: "",
      },
      {
        heading: "Here’s the Game-Changer: Cavendor’s AI Agent —",
        content:
          "Think of the AI Agent as a dependable partner — one that knows the ins and outs of healthcare claims and takes over the tedious parts, so your staff doesn’t have to.",
        listHeading: "Here’s how it works:",
        list: [
          "Understands Claims Intelligently: Automatically pulls important data from forms, bills, and supporting documents.",
          "Speeds Things Up: Detects and flags errors quickly so claims move through the system faster.",
          "Fits Into What You Already Use: Seamlessly integrates with your existing software and workflows.",
          "Always Audit-Ready: Tracks every step, making compliance reporting easy and stress-free.",
        ],
        afterListContent: "",
      },
      {
        heading: "Real Benefits You Can Measure",
        content:
          "Switching to Agentic AI isn’t just about convenience — it brings measurable improvements across your organization:",
        listHeading: "",
        list: [
          "Quicker Payments: Claims that used to take days can now be processed in hours.",
          "Improved Accuracy: Automated error checks reduce rework and rejected submissions.",
          "Reduced Costs: Less manual handling means more efficient operations.",
          "Happier Stakeholders: Patients and partners enjoy faster service and better communication.",
          "Live Visibility: Dashboards show what’s working, what’s lagging, and where to focus next.",
        ],
        afterListContent: "",
      },
      {
        heading: "Why Canvendor?",
        content:
          "At Canvendor, we don’t just make tools — we understand the real-world challenges that healthcare teams face.",
        listHeading:
          "That’s why we designed Agentic AI with features that matter:",
        list: [
          "Easy to implement and use",
          "Highly secure and scalable",
          "Compatible with your current workflows — no major overhauls required",
        ],
        afterListContent:
          "It’s smart automation that delivers — plain and simple.",
      },
      {
        heading: "Ready to Upgrade Your Claims Process?",
        content:
          "Let Agentic AI show you what’s possible when claims are done the smart way.",
        listHeading: "",
        list: [],
        afterListContent: "",
      },
    ],
    author: {
      name: "Raison",
      role: "UI/UX Designer - Cavendor",
      image: "https://c.animaapp.com/memovagbcMSRxN/img/ellipse-11.svg",
      bio: "TL; DR Health claims, reimagined! Canvendor's Agentic AI slashes delays, kills errors, and puts your claims on autopilot. Fast. Smart. Hassle-free.",
    },
  },
  {
    id: 4,
    title:
      "How Agentic AI Will Transform Healthcare Claims Automation in 2026 and Beyond",
    image: "/BlogsImages/blogBannerImage.jpg",
    sections: [
      {
        heading: "TL;DR:",
        content:
          "Agentic AI is redefining healthcare claims automation by 2026 eliminating manual errors, cutting denials by up to 40%, and processing claims 70% faster. Built for global compliance and adaptive intelligence, it learns, evolves, and delivers real-time accuracy so healthcare providers can focus on patients, not paperwork.",
        listHeading: "",
        list: [],
        afterListContent: "",
      },
      {
        // heading: "",
        content:
          "The healthcare industry is stepping into a new era of automation driven by intelligence, precision, and speed. As we move closer to 2026, Agentic AI is reshaping how hospitals and clinics handle claims processing, setting new standards for efficiency and accuracy. Manual claims management has always been a bottleneck for healthcare providers. Endless paperwork, coding errors, and compliance challenges slow down operations and impact profitability. But with AI-powered healthcare claims automation, these issues are being eliminated, allowing providers to focus on what truly matters — delivering quality patient care.",
        listHeading: "",
        list: [],
        afterListContent: "",
      },
      {
        heading: "Why Manual Claims Processing No Longer Works",
        content:
          "Every year, healthcare organizations lose billions due to outdated manual claims handling. It’s estimated that around $210 billion is lost globally to claim errors, processing delays, and denials.",
        listHeading: "Common issues faced by providers today include:",
        list: [
          "10–15% error rates in coding and billing",
          "Lengthy reimbursement cycles",
          "Revenue loss from delayed or denied claims",
          "Costly compliance penalties",
          "Short-staffed teams and rising administrative overheads",
        ],
        afterListContent:
          "Clearly, the healthcare industry needs a smarter, more adaptive approach — one that combines AI automation, predictive analytics, and intelligent data management to streamline claims handling from start to finish.",
      },
      {
        heading: "What Makes Agentic AI Different",
        content:
          "Traditional automation only performs tasks — it doesn’t learn or adapt. Agentic AI changes the game. It continuously analyzes claims, learns from outcomes, and automatically adjusts to payer-specific rules without human intervention.  ",
        content1:
          "Legacy revenue cycle management (RCM) systems rely on fixed rules. If a payer modifies their eligibility or coding requirements, manual reconfiguration becomes necessary.",
        content2:
          "Canvendor’s Agentic AI, on the other hand, uses autonomous intelligent agents that monitor payer behavior, identify denial trends, and proactively update claim logic. The more it processes, the smarter it gets, saving both time and money.",
        listHeading: "",
        list: [],
        afterListContent: "",
      },
      {
        heading: "How Agentic AI Revolutionizes Claims Automation",
        content:
          "Agentic AI transforms healthcare claims management by integrating intelligence across every stage of processing.",
        listHeading: "",
        list: [
          "Smart Data Extraction: Uses NLP to automatically capture data from EHR systems such as Epic, Cerner, and Athenahealth, eliminating manual entry.",
          "Real-Time Validation and Error Prevention: Checks claims against payer-specific rules, eligibility, and ICD-10/CPT code accuracy before submission.",
          "Intelligent Autonomous Adjudication: Applies business logic to autonomously recommend or execute Pay, Deny, or Pend actions — routing complex cases to human review.",
          "Compliant and Audit-Ready Processing: Ensures HIPAA, SOC 2, and GDPR compliance with encrypted data and full audit trails.",
        ],
        afterListContent: "",
      },
      {
        heading: "Real Impact, Real Results",
        content:
          "Our pilot programs with major healthcare networks have delivered measurable improvements across performance metrics.",
        listHeading: "Here’s what healthcare providers achieved:",
        list: [
          "Claims Processing Speed: 70% faster (weeks reduced to minutes)",
          "Coding Accuracy: 99% accuracy achieved",
          "Denial Reduction: 40% fewer denials through predictive eligibility",
          "Automation: 24/7 claim processing without manual queues",
          "ROI Timeframe: 6–12 months from implementation",
        ],
        afterListContent:
          "Early adopters have reported annual savings between $2 million and $5 million, depending on their size and claim volume.",
      },
      {
        heading: "Built on Security, Designed for Trust",
        content:
          "Data security is a cornerstone of Canvendor’s platform. Our infrastructure is built for compliance, reliability, and transparency from the ground up.",
        listHeading: "",
        list: [
          "Fully HIPAA-compliant for patient data protection",
          "SOC 2 Type II certified for system integrity",
          "GDPR-ready for international healthcare networks",
          "End-to-end encryption and secure data flow",
          "Role-based access controls with detailed audit logs",
          "Zero-trust security architecture",
        ],
        afterListContent:
          "Every claim action is traceable and auditable, ensuring total transparency and peace of mind.",
      },
      {
        heading: "Flexible Plans and ROI",
        content:
          "Canvendor’s Agentic AI platform offers flexible deployment and subscription options tailored to each healthcare provider’s size and volume. Whether you’re a small clinic or a large hospital network, our AI-powered system is designed to deliver measurable ROI through faster reimbursements, reduced denials, and improved staff efficiency.",
        listHeading: "",
        list: [],
        afterListContent: "",
      },
      {
        heading: "Why Leading Healthcare Providers Choose Agentic AI",
        content:
          "Hospitals and clinics are turning to Agentic AI because traditional RCM tools can no longer keep up with evolving payer systems.",
        listHeading: "Key benefits include:",
        list: [
          "Management of 500+ payer rules without manual effort",
          "Real-time adaptation to coding and eligibility changes",
          "Predictive denial prevention and improved revenue retention",
          "Reduced manual workload and improved staff retention",
          "End-to-end compliance and audit readiness",
        ],
        listHeading1: "Ideal for:",
        list1: [
          "Large hospital networks (100K+ annual claims)",
          "Multispecialty practices managing multiple payers",
          "Regional health systems modernizing RCM infrastructure",
          "Providers facing denial and revenue leakage challenges",
        ],
        afterListContent:
          "Ideal for large hospital networks, multispecialty practices, and regional health systems modernizing their RCM infrastructure, Providers facing denial and revenue leakage challenges",
      },
      {
        heading: "The Future of Healthcare Automation: 2026 and Beyond",
        content:
          "Agentic AI represents the next evolution of digital transformation in healthcare — an adaptive intelligence that continuously learns, predicts, and evolves.",
        listHeading: "",
        list: [],
        afterListContent:
          "By implementing AI-powered claims automation today, healthcare providers can achieve faster reimbursements, reduced denials, and optimized revenue cycles, ensuring they stay ahead in an increasingly competitive landscape.",
      },
      {
        heading: "Ready to Experience Agentic AI?",
        content:
          "Schedule a personalized demo to see how your organization can transform its claims process, or request a free claims audit to identify immediate areas for improvement.",
        listHeading: "",
        list: [],
        afterListContent: "",
      },
    ],
    author: {
      name: "",
      role: "Team Marketing - Canvendor",
      image: "/logo512.png",
      bio: "",
    },
  },

  {
    id: 5,
    title: "Cut QA Costs by 50%: How Agentic AI Automation Delivers Real ROI",
    image: "/BlogsImages/blogBannerImage2.png",
    sections: [
      {
        heading: "TL;DR",
        content:
          "Cut QA costs by 50% and double your test coverage with Agentic AI Automation from Canvendor smart, self-healing, and built for faster, more accurate testing.",
        listHeading: "",
        list: [],
        afterListContent: "",
      },
      {
        heading: "Imagine This",
        content:
          "Your QA team just wrapped up another long sprint. Test scripts are breaking again because of minor UI changes, deadlines are tight, and costs keep climbing. Sound familiar?",
        content1:
          "Now imagine the same team completing twice the test coverage in half the time without writing a single new script. That's not wishful thinking. That's Agentic AI Automation, powered by Canvendor.",
        content2:
          "In this post, we'll break down how Agentic AI doesn't just make testing smarter it makes it cheaper, faster, and more effective, delivering real return on investment that modern enterprises can feel.",
        listHeading: "",
        list: [],
        afterListContent: "",
      },
      {
        heading: "The Cost Challenge in QA Today",
        content:
          "Quality Assurance has always been the quiet hero of software development. But it's also the most resource-intensive part of the process.",
        listHeading: "",
        list: [
          "Test scripts break with every minor UI tweak.",
          "Manual testing eats up valuable developer and tester hours.",
          "Scaling automation requires constant maintenance and expertise.",
        ],
        afterListContent:
          "The result? A never-ending cycle of rising QA costs and slower release cycles, where teams spend more time fixing tests than improving quality.",
        afterListContent1:
          "It's time for a smarter solution, one that doesn't just automate tasks but thinks and adapts like your best QA engineer.",
      },
      {
        heading: "Enter Agentic AI Automation",
        content:
          "The Agentic AI Test Automation Platform from Canvendor brings together Generative AI and autonomous intelligence to transform the way you test software.",
        content1:
          "This isn't your traditional test automation tool it's automation that automates itself.",
        listHeading: "Here's what makes it different:",
        list: [
          "Self-Healing Tests: No more chasing broken scripts. Tests automatically adapt to UI changes.",
          "Low-Code/No-Code Creation: Empower non-technical teams to design tests visually no complex scripting required.",
          "Cross-Platform Support: Web, mobile, API, and enterprise app testing under one roof.",
          "Continuous Learning: AI algorithms learn from past runs, improving accuracy and reducing redundancy.",
        ],
        afterListContent:
          "Agentic AI doesn't just perform tasks it understands context, adapts, and improves with every iteration.",
      },
      {
        heading: "The 50% Cost Savings Explained",
        content:
          "Let's talk about the part every business cares about: ROI. By eliminating repetitive manual work and reducing script maintenance, Agentic AI delivers measurable cost efficiency across the QA lifecycle:",
        listHeading: "",
        list: [
          "Test Maintenance: Manual fixes for each UI update → Self-healing automation → 30% Savings",
          "Test Creation: Requires skilled developers → Low-code, AI-assisted creation → 20% Savings",
          "Test Execution: Sequential, slow runs → Parallel, autonomous execution → 25% Savings",
          "Rework: High, due to changing environments → Adaptive learning minimizes errors → 15% Savings",
        ],
        afterListContent:
          "Result: Up to 50% lower overall QA costs, with faster releases and higher test coverage.",
        afterListContent1:
          "It's not just about spending less it's about doing more with the same resources.",
      },
      {
        heading: "Real ROI: More Than Just Numbers",
        content:
          "When teams adopt Agentic AI, they don't just save money, they unlock new potential.",
        listHeading: "",
        list: [
          "2X Test Coverage: AI identifies additional edge cases that humans might overlook.",
          "40% Faster Release Cycles: Continuous testing keeps development moving without bottlenecks.",
          "Higher Quality Output: Predictive testing detects issues before they impact production.",
          "Empowered Teams: Testers can focus on strategy and innovation instead of maintenance.",
        ],
        afterListContent:
          "A leading enterprise using Agentic AI reported: 'Within six months, our QA costs dropped by nearly half. But the real win was our newfound confidence to release faster without compromising quality.'",
      },
      {
        heading: "The Future of QA Is Agentic",
        content:
          "Software testing has entered a new era one where AI doesn't just assist, it leads.",
        content1:
          "Agentic AI represents the shift from reactive automation to proactive intelligence, where systems can think, learn, and evolve.",
        content2:
          "In an environment where speed defines success, this isn't a luxury, it's a necessity.",
        listHeading: "",
        list: [],
        afterListContent: "",
      },
      {
        heading: "Conclusion",
        content:
          "If you're still treating QA as a cost center, it's time to rethink.",
        content1:
          "With Agentic AI Automation, testing becomes a growth enabler, cutting costs, improving accuracy, and freeing your team to focus on innovation.",
        listHeading: "",
        list: [
          "Deliver quality faster",
          "Cut costs smarter",
          "Experience the real ROI of AI-driven automation today",
        ],
        afterListContent: "",
      },
    ],
    author: {
      name: "Canvendor AI Team",
      role: "Quality Assurance & Automation",
      image: "/logo512.png",
      bio: "Driving innovation in software testing through intelligent automation and AI-powered solutions.",
    },
  },
];
